// Base URL of the Express API. REACT_APP_BACKEND_URL is baked in at build time,
// so set it in Cloudflare Pages before building; local development falls back
// to the dev server.
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:5006').replace(/\/$/, '');
